var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rkm-data-table',{ref:"RkmDataTable",attrs:{"fields":_vm.fields,"repository":_vm.repositories.cadastro.bairro}})}
var staticRenderFns = []

export { render, staticRenderFns }